/* ════════════════════════════════════════════════════════════
   VELVET RITUALS — Warranty page behaviour
   assets/vr-warranty.js

   1. Scroll reveal for .vrw-r (same spring pattern as vr-ai.js)
   2. Register Warranty form: date cap, invoice file handling
      (base64 into a hidden field — native Shopify contact forms
      cannot carry multipart attachments), inline validation.
   Self-guards so multiple section includes run it once.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__vrWarrantyInit) return;
  window.__vrWarrantyInit = true;

  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  ready(function () {
    /* ── Scroll reveal ─────────────────────────────────── */
    var revealEls = document.querySelectorAll('.vrw-r');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('in'); });
    }

    /* ── Register form ─────────────────────────────────── */
    var form = document.querySelector('[data-vrw-form]');
    if (!form) return;

    /* "Other" option reveals a type-your-own field. The typed value
       is written into the option's value, so it posts under the same
       contact[...] field name. */
    form.querySelectorAll('select[data-vrw-has-other]').forEach(function (select) {
      var field = select.closest('.vrw__field');
      var input = field && field.querySelector('[data-vrw-other-input]');
      var otherOpt = select.querySelector('option[data-vrw-other]');
      if (!input || !otherOpt) return;
      var defaultValue = otherOpt.value;

      var update = function (focusIt) {
        var sel = select.options[select.selectedIndex];
        var isOther = sel && sel.hasAttribute('data-vrw-other');
        input.classList.toggle('show', isOther);
        input.required = isOther;
        if (isOther) {
          if (focusIt) input.focus();
        } else {
          otherOpt.value = defaultValue;
          input.value = '';
        }
      };
      select.addEventListener('change', function () { update(true); });
      input.addEventListener('input', function () {
        otherOpt.value = input.value.trim() || defaultValue;
      });
      update(false);
    });

    /* Device dropdown with product thumbnails — progressive
       enhancement over the native select, which stays in the DOM
       and carries the submitted value. */
    var THUMB_SVG = '<span class="vrw__dd-thumb" aria-hidden="true"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 7.5L12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5L12 12l8.5-4.5M12 12v9"/></svg></span>';

    form.querySelectorAll('[data-vrw-dd]').forEach(function (wrap) {
      var select = wrap.querySelector('select');
      if (!select) return;
      wrap.classList.add('is-enhanced');
      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vrw__dd-btn';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');

      var panel = document.createElement('ul');
      panel.className = 'vrw__dd-panel';
      panel.setAttribute('role', 'listbox');
      panel.id = (select.id || 'vrw-dd') + '-listbox';
      btn.setAttribute('aria-controls', panel.id);

      var items = [];
      var active = -1;
      // Text-only selects (no option images) skip thumbnails entirely
      var hasImgs = !!select.querySelector('option[data-img]');

      var optThumb = function (opt) {
        if (opt.dataset.img) {
          var img = document.createElement('img');
          img.src = opt.dataset.img;
          img.alt = '';
          img.loading = 'lazy';
          return img;
        }
        var span = document.createElement('span');
        span.innerHTML = THUMB_SVG;
        return span.firstChild;
      };

      var setBtn = function () {
        var opt = select.options[select.selectedIndex];
        btn.innerHTML = '';
        var isPlaceholder = !opt || opt.disabled;
        btn.classList.toggle('is-placeholder', isPlaceholder);
        if (hasImgs && !isPlaceholder) btn.appendChild(optThumb(opt));
        var label = document.createElement('span');
        label.className = 'vrw__dd-label';
        label.textContent = opt ? opt.text : '';
        btn.appendChild(label);
        var chev = document.createElement('span');
        chev.className = 'vrw__dd-chev';
        chev.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
        btn.appendChild(chev);
      };

      var mark = function () {
        items.forEach(function (it) {
          var selected = it.optIndex === select.selectedIndex;
          it.el.setAttribute('aria-selected', selected ? 'true' : 'false');
          it.el.classList.toggle('active', items.indexOf(it) === active);
        });
      };

      var open = function () {
        wrap.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        active = items.findIndex(function (it) { return it.optIndex === select.selectedIndex; });
        mark();
        if (active > -1 && items[active]) items[active].el.scrollIntoView({ block: 'nearest' });
      };
      var close = function () {
        wrap.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        active = -1;
      };
      var isOpen = function () { return wrap.classList.contains('open'); };

      var choose = function (optIndex) {
        select.selectedIndex = optIndex;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        setBtn();
        mark();
      };

      Array.prototype.forEach.call(select.options, function (opt, i) {
        if (opt.disabled) return;
        var li = document.createElement('li');
        li.className = 'vrw__dd-opt';
        li.setAttribute('role', 'option');
        if (hasImgs) li.appendChild(optThumb(opt));
        var label = document.createElement('span');
        label.className = 'vrw__dd-label';
        label.textContent = opt.text;
        li.appendChild(label);
        li.addEventListener('click', function () { choose(i); close(); btn.focus(); });
        li.addEventListener('mousemove', function () {
          active = items.findIndex(function (it) { return it.el === li; });
          mark();
        });
        panel.appendChild(li);
        items.push({ el: li, optIndex: i });
      });

      btn.addEventListener('click', function () { isOpen() ? close() : open(); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          if (!isOpen()) { open(); return; }
          var dir = e.key === 'ArrowDown' ? 1 : -1;
          active = Math.min(items.length - 1, Math.max(0, active + dir));
          mark();
          if (items[active]) items[active].el.scrollIntoView({ block: 'nearest' });
        } else if ((e.key === 'Enter' || e.key === ' ') && isOpen()) {
          e.preventDefault();
          if (active > -1 && items[active]) choose(items[active].optIndex);
          close();
        } else if (e.key === 'Escape' && isOpen()) {
          e.preventDefault();
          close();
        }
      });
      document.addEventListener('click', function (e) {
        if (isOpen() && !wrap.contains(e.target)) close();
      });

      setBtn();
      mark();
      wrap.appendChild(btn);
      wrap.appendChild(panel);
    });

    // Purchase date can't be in the future
    var dateInput = form.querySelector('input[type="date"]');
    if (dateInput) {
      var now = new Date();
      var pad = function (n) { return String(n).padStart(2, '0'); };
      dateInput.max = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
    }

    // Invoice upload → base64 into hidden field
    var drop = form.querySelector('[data-vrw-drop]');
    var fileInput = drop && drop.querySelector('input[type="file"]');
    var hiddenB64 = form.querySelector('[data-vrw-invoice-b64]');
    var hiddenMeta = form.querySelector('[data-vrw-invoice-meta]');
    var dropText = drop && drop.querySelector('[data-vrw-drop-text]');
    var dropDefault = dropText ? dropText.innerHTML : '';
    var fileErr = form.querySelector('[data-vrw-file-err]');
    var MAX_BYTES = 2 * 1024 * 1024; // 2 MB — keeps the notification email deliverable
    var OK_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];

    var setFileError = function (msg) {
      if (!fileErr) return;
      fileErr.textContent = msg || '';
      fileErr.classList.toggle('show', !!msg);
    };

    var clearFile = function () {
      if (fileInput) fileInput.value = '';
      if (hiddenB64) hiddenB64.value = '';
      if (hiddenMeta) hiddenMeta.value = 'No invoice attached';
      if (dropText) dropText.innerHTML = dropDefault;
      if (drop) drop.classList.remove('has-file');
    };

    var handleFile = function (file) {
      setFileError('');
      if (!file) { clearFile(); return; }
      if (OK_TYPES.indexOf(file.type) === -1) {
        clearFile();
        setFileError('Please upload a JPG, PNG or PDF.');
        return;
      }
      if (file.size > MAX_BYTES) {
        clearFile();
        setFileError('That file is over 2 MB. A phone photo or a compressed PDF works best.');
        return;
      }
      var reader = new FileReader();
      reader.onload = function () {
        if (hiddenB64) hiddenB64.value = reader.result;
        if (hiddenMeta) hiddenMeta.value = file.name + ' (' + Math.round(file.size / 1024) + ' KB)';
        if (dropText) {
          dropText.innerHTML = '<strong>' + file.name.replace(/[<>&]/g, '') + '</strong><br>' +
            Math.round(file.size / 1024) + ' KB · tap to replace';
        }
        if (drop) drop.classList.add('has-file');
        maybeUploadToAzure();
      };
      reader.onerror = function () {
        clearFile();
        setFileError('We could not read that file. Please try another one.');
      };
      reader.readAsDataURL(file);
    };

    /* Eager Azure upload: fires the moment a file is selected, and
       re-fires (debounced) whenever an identifying field changes —
       so the filename (built from the email + a hash of the
       identifying fields, server-side) reflects whatever's actually
       filled in by the time it settles, regardless of the order the
       customer fills the form in. Entirely decoupled from the submit
       event — this runs seconds before submit, while the customer is
       still filling the form — so unlike the sheet-logging relay
       below, it CAN afford a normal read-and-wait fetch (we need the
       resulting blob URL back). A sequence counter discards any
       response that's been superseded by a newer request before it
       returned. */
    var sheetUrl = form.getAttribute('data-vrw-sheet-url');
    var invoiceBlobField = form.querySelector('[data-vrw-invoice-blob-url]');
    var azureUploadTimer;
    var azureUploadSeq = 0;

    var maybeUploadToAzure = function () {
      if (!sheetUrl || !hiddenB64 || !hiddenB64.value) return;
      clearTimeout(azureUploadTimer);
      azureUploadTimer = setTimeout(function () {
        var mySeq = ++azureUploadSeq;
        var emailEl = form.querySelector('#vrw-email');
        var phoneEl = form.querySelector('#vrw-phone');
        var deviceEl = form.querySelector('#vrw-device');
        var dateEl = form.querySelector('#vrw-date');
        var payload = {
          action: 'uploadInvoice',
          invoiceData: hiddenB64.value,
          'contact[email]': emailEl ? emailEl.value : '',
          'contact[phone]': phoneEl ? phoneEl.value : '',
          'contact[Device]': deviceEl ? deviceEl.value : '',
          'contact[Date of purchase]': dateEl ? dateEl.value : ''
        };
        fetch(sheetUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json(); })
          .then(function (result) {
            if (mySeq !== azureUploadSeq) return; // superseded by a newer attempt
            if (result && result.ok && result.blobUrl && invoiceBlobField) {
              invoiceBlobField.value = result.blobUrl;
            }
          })
          .catch(function () {
            /* Best-effort only — if this never completes, the sheet
               row just falls back to "no image" and the invoice still
               arrives the old way, base64 in the notification email. */
          });
      }, 700);
    };

    if (sheetUrl) {
      ['#vrw-email', '#vrw-phone', '#vrw-device', '#vrw-date'].forEach(function (sel) {
        var el = form.querySelector(sel);
        if (!el) return;
        el.addEventListener('blur', maybeUploadToAzure);
        el.addEventListener('change', maybeUploadToAzure);
      });
      form.querySelectorAll('[data-vrw-other-input]').forEach(function (el) {
        el.addEventListener('input', maybeUploadToAzure);
      });
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () { handleFile(fileInput.files[0]); });
    }
    if (drop) {
      ['dragenter', 'dragover'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); });
      });
      drop.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) {
          handleFile(e.dataTransfer.files[0]);
        }
      });
    }

    // Never post the raw file — the base64 hidden field carries it
    form.addEventListener('submit', function () {
      if (fileInput) fileInput.disabled = true;
      var btn = form.querySelector('[data-vrw-submit]');
      if (btn) {
        btn.disabled = true;
        btn.dataset.label = btn.textContent;
        btn.textContent = 'Registering…';
      }
    });

    /* Optional: mirror the structured registration details to a Google
       Sheet via an Apps Script Web App. The sheet URL is a section
       setting (data-vrw-sheet-url); if it's blank this is a no-op.

       NOT fetch + intercepted/delayed resubmission — an earlier version
       tried that and broke real submissions with "Invalid CAPTCHA
       token": Shopify's own contact-form spam protection (hCaptcha) has
       its own async flow tied to this same submit, and delaying or
       re-triggering the submission — by any method — raced against or
       bypassed it. This never calls preventDefault or touches the
       submit event's default action at all, so it cannot interfere
       with Shopify's form handling no matter how that's implemented
       internally.

       Also NOT navigator.sendBeacon, despite that being the textbook
       "fire on submit, survive navigation" tool: Apps Script Web Apps
       always respond with a redirect, and sendBeacon's simplified
       transport doesn't reliably follow redirects — the request can
       leave the browser and still never actually reach the script.
       fetch(..., { keepalive: true }) gets the same survives-navigation
       guarantee while still following redirects like a normal request.
       keepalive has its own small payload ceiling (~64KB), which is
       also why the invoice file itself isn't sent this way — the
       payload here picks up "contact[Invoice Blob URL]" instead (set
       earlier by the eager Azure upload above, if it completed in
       time), falling back to nothing if it didn't. */
    if (sheetUrl && window.fetch) {
      form.addEventListener('submit', function () {
        var payload = {};
        new FormData(form).forEach(function (value, key) {
          if (key === 'contact[Invoice data]') return; // too large for keepalive
          payload[key] = value;
        });
        payload['Page URL'] = window.location.href;
        fetch(sheetUrl, {
          method: 'POST',
          mode: 'no-cors',
          keepalive: true,
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload)
        }).catch(function () {});
      });
    }

    // If we returned from a successful post, bring the banner into view
    var banner = document.querySelector('[data-vrw-posted]');
    if (banner && window.location.hash.indexOf('vrw-register') !== -1) {
      banner.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  });
})();
